import { render, staticRenderFns } from "./Manage-Insurance-Company.vue?vue&type=template&id=54a83a2e"
import script from "./Manage-Insurance-Company.vue?vue&type=script&lang=js"
export * from "./Manage-Insurance-Company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports